// THIS FILE IS AUTOMATICALLY GENERATED. DO NOT MODIFY IT MANUALLY.

/**
 * Design System theme object.
 *
 * Theme name: `classic`
 *
 * Theme mode: `light`
 */
export default {
  color: {
    'fill-surface-default': '#ffffff',
    'fill-surface-default-hover': '#242424',
    'fill-surface-default-pressed': '#292929',
    'fill-surface-recessed': '#253342',
    'fill-surface-raised': '#F5F8FA',
    'fill-surface-overlay': '#333333',
    'fill-primary-default': '#FF7A59',
    'fill-primary-hover': '#FF8F73',
    'fill-primary-pressed': '#E66E50',
    'fill-primary-subtle': '#FFF1EE',
    'fill-secondary-default': '#00A4BD',
    'fill-secondary-hover': '#7FD1DE',
    'fill-secondary-pressed': '#0091AE',
    'fill-secondary-subtle': '#E5F5F8',
    'fill-tertiary-default': '#EAF0F6',
    'fill-tertiary-hover': '#F5F8FA',
    'fill-tertiary-pressed': '#CBD6E2',
    'fill-tertiary-subtle': '#DFE3EB',
    'fill-brand-default': '#FF7A59',
    'fill-brand-hover': '#FF8F73',
    'fill-brand-pressed': '#E66E50',
    'fill-brand-subtle': '#FFF1EE',
    'fill-positive-default': '#00BDA5',
    'fill-positive-hover': '#7FDED2',
    'fill-positive-pressed': '#00A38D',
    'fill-positive-subtle': '#E5F8F6',
    'fill-positive-alt': '#38D84C',
    'fill-caution-default': '#F5C26B',
    'fill-caution-hover': '#FAE0B5',
    'fill-caution-pressed': '#DBAE60',
    'fill-caution-subtle': '#FEF8F0',
    'fill-caution-alt': '#FCCB57',
    'fill-alert-default': '#F2545B',
    'fill-alert-hover': '#FF5962',
    'fill-alert-pressed': '#D94C53',
    'fill-alert-subtle': '#FDEDEE',
    'fill-info-default': '#00A4BD',
    'fill-info-hover': '#7FD1DE',
    'fill-info-pressed': '#0091AE',
    'fill-info-subtle': '#E5F5F8',
    'fill-accent-purple-default': '#6A78D1',
    'fill-accent-purple-hover': '#B4BBE8',
    'fill-accent-purple-pressed': '#5E6AB8',
    'fill-accent-purple-subtle': '#F0F1FA',
    'fill-accent-orange-default': '#FF7A59',
    'fill-accent-orange-hover': '#FFBCAC',
    'fill-accent-orange-pressed': '#E66E50',
    'fill-accent-orange-subtle': '#FFF1EE',
    'fill-accent-green-default': '#00BDA5',
    'fill-accent-green-hover': '#7FDED2',
    'fill-accent-green-pressed': '#00A38D',
    'fill-accent-green-subtle': '#E5F8F6',
    'fill-accent-yellow-default': '#F5C26B',
    'fill-accent-yellow-hover': '#FAE0B5',
    'fill-accent-yellow-pressed': '#DBAE60',
    'fill-accent-yellow-subtle': '#FEF8F0',
    'fill-accent-red-default': '#F2545B',
    'fill-accent-red-hover': '#F8A9AD',
    'fill-accent-red-pressed': '#D94C53',
    'fill-accent-red-subtle': '#FDEDEE',
    'fill-accent-blue-default': '#00A4BD',
    'fill-accent-blue-hover': '#7FD1DE',
    'fill-accent-blue-pressed': '#0091AE',
    'fill-accent-blue-subtle': '#E5F5F8',
    'fill-accent-teal-default': '#007C7D',
    'fill-accent-teal-hover': '#006162',
    'fill-accent-teal-pressed': '#00494B',
    'fill-accent-teal-subtle': '#051919',
    'fill-accent-magenta-default': '#F2547D',
    'fill-accent-magenta-hover': '#F9AABE',
    'fill-accent-magenta-pressed': '#D94C71',
    'fill-accent-magenta-subtle': '#FDEDF2',
    'fill-transparent-default': 'rgba(0,0,0,0)',
    'text-primary-default': '#33475B',
    'text-primary-subtle': '#516F90',
    'text-primary-disabled': '#99ACC2',
    'text-primary-on-fill-default': '#ffffff',
    'text-primary-on-fill-subtle': '#B6B1AF',
    'text-interactive-default': '#0091AE',
    'text-interactive-on-fill-default': '#FFFFFF',
    'text-interactive-on-fill-subtle': '#C4B4F7',
    'text-brand-default': '#FF7A59',
    'text-brand-on-fill-default': '#ffffff',
    'text-brand-on-fill-subtle': '#FFA581',
    'text-positive-default': '#00BDA5',
    'text-positive-on-fill-default': '#ffffff',
    'text-positive-on-fill-subtle': '#38D84C',
    'text-positive-on-fill-alt': '#042905',
    'text-caution-default': '#D39913',
    'text-caution-on-fill-default': '#1F1F1F',
    'text-caution-on-fill-subtle': '#EEB117',
    'text-caution-on-fill-alt': '#331E06',
    'text-alert-default': '#F2545B',
    'text-alert-on-fill-default': '#FFFFFF',
    'text-alert-on-fill-subtle': '#FF7B70',
    'text-info-default': '#5CAAFF',
    'text-info-on-fill-default': '#FFFFFF',
    'text-info-on-fill-subtle': '#8CC4F4',
    'text-accent-green-default': '#27BD3E',
    'text-accent-green-on-fill-default': '#FFFFFF',
    'text-accent-green-on-fill-subtle': '#38D84C',
    'text-accent-yellow-default': '#D39913',
    'text-accent-yellow-on-fill-default': '#FFFFFF',
    'text-accent-yellow-on-fill-subtle': '#EEB117',
    'text-accent-red-default': '#FF7B70',
    'text-accent-red-on-fill-default': '#FFFFFF',
    'text-accent-red-on-fill-subtle': '#FFA499',
    'text-accent-blue-default': '#5CAAFF',
    'text-accent-blue-on-fill-default': '#FFFFFF',
    'text-accent-blue-on-fill-subtle': '#8CC4F4',
    'text-accent-teal-default': '#21B7B7',
    'text-accent-teal-on-fill-default': '#FFFFFF',
    'text-accent-teal-on-fill-subtle': '#48D1CF',
    'text-accent-magenta-default': '#FF72BA',
    'text-accent-magenta-on-fill-default': '#FFFFFF',
    'text-accent-magenta-on-fill-subtle': '#FF9FCC',
    'text-accent-purple-default': '#AC98F8',
    'text-accent-purple-on-fill-default': '#FFFFFF',
    'text-accent-purple-on-fill-subtle': '#C4B4F7',
    'icon-primary-default': '#7C98B6',
    'icon-primary-on-fill-default': '#ffffff',
    'icon-primary-on-fill-subtle': '#B6B1AF',
    'icon-interactive-default': '#0091AE',
    'icon-interactive-on-fill-default': '#ffffff',
    'icon-interactive-on-fill-subtle': '#C4B4F7',
    'icon-brand-default': '#FFA581',
    'icon-brand-on-fill-default': '#411204',
    'icon-brand-on-fill-subtle': '#FFA581',
    'icon-positive-default': '#38D84C',
    'icon-positive-on-fill-default': '#FFFFFF',
    'icon-positive-on-fill-subtle': '#38D84C',
    'icon-positive-on-fill-alt': '#042905',
    'icon-caution-default': '#EEB117',
    'icon-caution-on-fill-default': '#1F1F1F',
    'icon-caution-on-fill-subtle': '#EEB117',
    'icon-caution-on-fill-alt': '#331E06',
    'icon-alert-default': '#F2545B',
    'icon-alert-on-fill-default': '#ffffff',
    'icon-alert-on-fill-subtle': '#FF7B70',
    'icon-info-default': '#8CC4F4',
    'icon-info-on-fill-default': '#FFFFFF',
    'icon-info-on-fill-subtle': '#8CC4F4',
    'icon-accent-green-default': '#38D84C',
    'icon-accent-green-on-fill-default': '#FFFFFF',
    'icon-accent-green-on-fill-subtle': '#38D84C',
    'icon-accent-yellow-default': '#EEB117',
    'icon-accent-yellow-on-fill-default': '#1F1F1F',
    'icon-accent-yellow-on-fill-subtle': '#EEB117',
    'icon-accent-red-default': '#FF3842',
    'icon-accent-red-on-fill-default': '#FFFFFF',
    'icon-accent-red-on-fill-subtle': '#FF7B70',
    'icon-accent-blue-default': '#8CC4F4',
    'icon-accent-blue-on-fill-default': '#FFFFFF',
    'icon-accent-blue-on-fill-subtle': '#8CC4F4',
    'icon-accent-teal-default': '#48D1CF',
    'icon-accent-teal-on-fill-default': '#FFFFFF',
    'icon-accent-teal-on-fill-subtle': '#48D1CF',
    'icon-accent-magenta-default': '#FF9FCC',
    'icon-accent-magenta-on-fill-default': '#FFFFFF',
    'icon-accent-magenta-on-fill-subtle': '#FF9FCC',
    'icon-accent-purple-default': '#C4B4F7',
    'icon-accent-purple-on-fill-default': '#FFFFFF',
    'icon-accent-purple-on-fill-subtle': '#C4B4F7',
    'icon-accent-orange-default': '#FFA581',
    'icon-accent-orange-on-fill-default': '#411204',
    'icon-accent-orange-on-fill-subtle': '#FFA581',
    'border-primary-default': '#CBD6E2',
    'border-primary-subtle-default': '#FFFFFF',
    'border-primary-subtle-hover': '#FFFFFF',
    'border-primary-subtle-pressed': '#7C98B6',
    'border-primary-on-fill-default': '#FFFFFF',
    'border-interactive-default': '#7FD1DE',
    'border-brand-default': '#FF7A59',
    'border-positive-default': '#00BDA5',
    'border-caution-default': '#F5C26B',
    'border-alert-default': '#F2545B',
    'border-info-default': '#00A4BD',
    'border-surface-default': '#FFFFFF',
    'specialty-notification': '#D9002B',
    'specialty-scrim': '#000000',
    'fill-tertiary-alt': '#CBD6E2',
    'fill-accent-light-orange-default': '#FF8F59',
    'fill-accent-light-orange-hover': '#FFC7AC',
    'fill-accent-light-orange-pressed': '#E68250',
    'fill-accent-light-orange-subtle': '#FFF3EE',
    'fill-accent-neutral-default': '#425B76',
    'fill-accent-neutral-hover': '#516F90',
    'fill-accent-neutral-pressed': '#33475B',
    'fill-accent-neutral-subtle': '#425B76',
    'text-interactive-default-hover': '#007A8C',
    'text-interactive-default-pressed': '#7FD1DE',
    'text-interactive-default-disabled': '#99ACC2',
    'text-interactive-on-fill': '#ffffff',
    'text-alert-hover': '#F8A9AD',
    'text-alert-pressed': '#D94C53',
    'text-alert-on-fill': '#ffffff',
    'icon-primary-hover': '#7C98B6',
    'icon-primary-pressed': '#33475B',
    'icon-interactive-hover': '#007A8C',
    'icon-interactive-pressed': '#7FD1DE',
    'icon-alert-hover': '#F8A9AD',
    'icon-alert-pressed': '#D94C53',
    'border-primary-subtle': '#DFE3EB',
    'border-primary-disabled': '#EAF0F6',
    'border-primary-on-fill': '#ffffff',
    'border-interactive-pressed': '#0091AE'
  },
  space: {
    '0': '0px',
    '25': '1px',
    '50': '2px',
    '100': '4px',
    '200': '8px',
    '300': '12px',
    '400': '16px',
    '500': '20px',
    '600': '24px',
    '700': '28px',
    '800': '32px',
    '900': '36px',
    '1000': '40px',
    '1100': '48px',
    '1200': '56px',
    '1300': '60px',
    '1400': '64px',
    '1500': '96px',
    '1600': '144px',
    '1700': '192px'
  },
  size: {
    'icon-100': '12px',
    'icon-200': '14px',
    'icon-300': '16px',
    'icon-400': '18px',
    'icon-500': '20px',
    'icon-600': '24px',
    'icon-700': '28px',
    'icon-800': '32px'
  },
  borderRadius: {
    '0': '0px',
    '100': '3px',
    '200': '4px',
    '300': '100px'
  },
  borderWidth: {
    '0': '0px',
    '100': '1px',
    '200': '2px',
    '300': '4px'
  },
  boxShadow: {
    '100': '0 1px 5px 0 rgba(44,61,79,0.12)',
    '200': '0 1px 4px 0 rgba(66,91,117,0.06)',
    '300': '0 3px 8px 0 rgba(0,0,0,0.1)',
    '400': '0 1px 24px 0 rgba(0,0,0,0.08)'
  },
  typography: {
    'display-100': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '500',
      fontSize: '56px',
      lineHeight: '72px',
      letterSpacing: '-0.32px'
    },
    'display-200': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '500',
      lineHeight: '76px',
      fontSize: '66px',
      letterSpacing: '-0.32px'
    },
    'display-300': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '500',
      fontSize: '76px',
      lineHeight: '88px',
      letterSpacing: '-0.32px'
    },
    'display-400': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '500',
      fontSize: '84px',
      lineHeight: '96px',
      letterSpacing: '-0.32px'
    },
    'display-500': {
      fontFamily: 'Lexend Deca',
      fontWeight: '500',
      fontSize: '94px',
      lineHeight: '100px',
      letterSpacing: '-0.32px'
    },
    'heading-25': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '600',
      fontSize: '12px',
      lineHeight: '18px',
      letterSpacing: '0px'
    },
    'heading-50': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '600',
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0px'
    },
    'heading-100': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '600',
      fontSize: '16px',
      lineHeight: '20px',
      letterSpacing: '0px'
    },
    'heading-200': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '500',
      fontSize: '18px',
      lineHeight: '24px',
      letterSpacing: '0px'
    },
    'heading-300': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '600',
      fontSize: '20px',
      lineHeight: '24px',
      letterSpacing: '0px'
    },
    'heading-400': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '500',
      fontSize: '22px',
      lineHeight: '27px',
      letterSpacing: '0px'
    },
    'heading-500': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '300',
      fontSize: '24px',
      lineHeight: '29px',
      letterSpacing: '0px'
    },
    'heading-600': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '700',
      fontSize: '32px',
      lineHeight: '39px',
      letterSpacing: '0px'
    },
    'heading-700': {
      fontSize: '36px',
      lineHeight: '44px',
      fontWeight: '500',
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      letterSpacing: '-0.16px'
    },
    'heading-800': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '500',
      fontSize: '42px',
      lineHeight: '52px',
      letterSpacing: '-0.16px'
    },
    'heading-900': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '500',
      fontSize: '46px',
      lineHeight: '56px',
      letterSpacing: '-0.16px'
    },
    'heading-1000': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '700',
      fontSize: '55px',
      lineHeight: '67px',
      letterSpacing: '0px'
    },
    'body-100': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '300',
      fontSize: '14px',
      lineHeight: '24px',
      letterSpacing: '0px'
    },
    'body-125': {
      fontFamily: 'Lexend Deca',
      fontWeight: '600',
      fontSize: '14px',
      lineHeight: '24px',
      letterSpacing: '0px'
    },
    'body-200': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '300',
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: '0px'
    },
    'body-300': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '400',
      fontSize: '18px',
      lineHeight: '24px',
      letterSpacing: '0px'
    },
    'body-400': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '400',
      fontSize: '20px',
      lineHeight: '28px',
      letterSpacing: '0px'
    },
    'body-500': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '400',
      fontSize: '22px',
      lineHeight: '28px',
      letterSpacing: '0px'
    },
    'body-600': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '400',
      fontSize: '26px',
      lineHeight: '32px',
      letterSpacing: '0px'
    },
    'body-700': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '400',
      fontSize: '28px',
      lineHeight: '36px',
      letterSpacing: '0px'
    },
    'detail-100': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '300',
      fontSize: '12px',
      lineHeight: '14px',
      letterSpacing: '0px'
    },
    'detail-200': {
      fontFamily: 'Lexend Deca, Helvetica, Arial, sans-serif',
      fontWeight: '300',
      fontSize: '12px',
      lineHeight: '18px',
      letterSpacing: '0px'
    },
    'code-100': {
      fontFamily: 'Source Code Pro, Consolas, Monaco, Courier New, monospace',
      fontWeight: '500',
      fontSize: '14px',
      lineHeight: '24px',
      letterSpacing: '0px'
    }
  }
};